<fc-dialog-header title="Choose customer"></fc-dialog-header>
<div class="list-container body p-24">
  <fc-form-field>
    <input
      #search
      (input)="store.setCustomerSearch(search.value)"
      fcFocusOnAppear
      fcInput
      placeholder="Search your organization"
    />
    <fc-icon icon="icon-search-outline" fcPrefix></fc-icon>
  </fc-form-field>
  <div class="text-lg pt-24">Organizations</div>
  <div
    (indexChange)="onCustomerSelectChange($event)"
    (selectItem)="
      store.switchCustomer(store.customerList()[store.customerIndex()])
    "
    [disabled]="store.isOpen()"
    [selectedIndex]="store.customerIndex()"
    fcArrowKeyNavigation
    fcCustomKeybinding
    key="e"
    [withCtrl]="true"
    (keyTrigger)="
      showEmployees(
        store.customerList()[store.customerIndex()].id,
        store.customerIndex(),
        trigger()
      )
    "
    class="list"
  >
    @if (store.customerLoading()) {
      <fc-skeleton-list [count]="4"></fc-skeleton-list>
    }
    @if (store.customerList().length === 0 && !store.customerLoading()) {
      <fc-empty-state title="No customers found" />
    }
    @for (customer of store.customerList(); track i; let i = $index) {
      <div
        class="item"
        #customerItem
        [class.active]="store.customerIndex() === i"
      >
        <div (click)="store.switchCustomer(customer)" class="item-description">
          <div class="flex flex-row justify-between flex-1">
            <div class="flex flex-row align-center gap-8">
              <fc-icon icon="icon-business"></fc-icon>
              <span class="text-base">{{ customer.name }}</span>
            </div>
            <span class="text-md color-grey-400"
              >{{ customer.employeeCount }} emp</span
            >
          </div>
        </div>

        <ng-button
          variant="outline"
          size="md"
          color="secondary"
          cdkOverlayOrigin
          #trigger="cdkOverlayOrigin"
          (click)="showEmployees(customer.id, i, trigger)"
          [iconOnly]="true"
          icon="icon-group-bold"
        />
      </div>
    }
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger()"
  [cdkConnectedOverlayOpen]="store.isOpen()"
  (detach)="store.setEmployeeSelectorOpen(false)"
  (backdropClick)="store.setEmployeeSelectorOpen(false)"
  [cdkConnectedOverlayBackdropClass]="['cdk-overlay-transparent-backdrop']"
  [cdkConnectedOverlayHasBackdrop]="true"
>
  <div class="employee-selector">
    <div class="flex header full-width flex-row justify-between align-center">
      <div class="title text-lg font-medium">Employee select</div>
      <ng-button
        variant="outline"
        class="close-button my-8"
        size="md"
        color="secondary"
        (click)="store.setEmployeeSelectorOpen(false)"
        [iconOnly]="true"
        icon="icon-close"
      />
    </div>
    <fc-form-field>
      <input
        #search
        (input)="store.setEmployeeSearch(search.value)"
        fcFocusOnAppear
        fcInput
        placeholder="Search employees"
      />
      <fc-icon icon="icon-search-outline" fcPrefix></fc-icon>
    </fc-form-field>

    <div
      fcArrowKeyNavigation
      [selectedIndex]="store.employeeIndex()"
      (indexChange)="store.setEmployeeIndex($event)"
      (selectItem)="
        store.switchEmployee(store.employeeList()[store.employeeIndex()])
      "
      class="employee-list"
    >
      @if (store.employeeList().length === 0 && !store.employeeLoading()) {
        <fc-empty-state title="No employees found" />
      }
      @if (store.employeeLoading()) {
        <fc-skeleton-list [count]="4"></fc-skeleton-list>
      }
      @for (employee of store.employeeList(); track i; let i = $index) {
        <div
          [class.active]="store.employeeIndex() === i"
          (click)="store.switchEmployee(employee)"
          class="employee-item"
        >
          <div class="employee-avatar">
            <fc-entity-avatar
              type="employee"
              [size]="20"
              [entity]="employee"
            ></fc-entity-avatar>
          </div>
          <div class="employee-name">
            <span>{{ employee.firstName }} {{ employee.lastName }}</span>
            @if (employee.isAdmin) {
              <fc-ng-tag color="error" hierarchy="secondary">Admin</fc-ng-tag>
            }
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
